import Vue from 'vue'
import { mapState } from 'vuex'

Vue.mixin({
  computed: {
    ...mapState({
      userRoles: (state) => (state.auth.user ? state.auth.user.authorities : ''),
    }),
  },
  methods: {
    accessFor(roles) {
      if (!this.userRoles) return false
      return roles.reduce((found, item) => found || this.userRoles.includes(item), false)
    },
  },
})
